import { render, staticRenderFns } from "./RemoteLearnMore.vue?vue&type=template&id=0027d92e&scoped=true&"
import script from "./RemoteLearnMore.vue?vue&type=script&lang=js&"
export * from "./RemoteLearnMore.vue?vue&type=script&lang=js&"
import style0 from "./RemoteLearnMore.vue?vue&type=style&index=0&id=0027d92e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0027d92e",
  null
  
)

export default component.exports